import { CommonModule } from "@angular/common";
import {
    booleanAttribute,
    Component,
    computed,
    input,
    output,
    signal,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { toObservableSignal } from "ngxtension/to-observable-signal";
import { Icon } from "../../icon/icon.component";
import { BaseInput } from "../base-input";
import { Input } from "../input.component";

@Component({
    selector: "app-input-password",
    standalone: true,
    imports: [CommonModule, Input, Icon],
    templateUrl: "./input-password.component.html",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputPassword,
            multi: true,
        },
    ],
})
export class InputPassword
    extends BaseInput<string>
    implements ControlValueAccessor
{
    regExp = input<boolean, string>(false, { transform: booleanAttribute });
    showPassword = signal(false);
    hideIcon = input<boolean>(false);
    icon = computed(() => (this.showPassword() ? "mdi:eye-off" : "mdi:eye"));
    currentType = computed(() => (this.showPassword() ? "text" : "password"));

    regExp1 = /^.{8,}$/;
    regExp2 = /(?=.*[a-z])(?=.*\d)/;
    regExp3 = /(?=.*[!@#$%^&*()#])/;

    testRegExp1 = computed(() => this.regExp1.test(this.value() || ""));
    testRegExp2 = computed(() => this.regExp2.test(this.value() || ""));
    testRegExp3 = computed(() => this.regExp3.test(this.value() || ""));

    valid = computed(
        () => this.testRegExp1() && this.testRegExp2() && this.testRegExp3(),
    );
    invalid = toObservableSignal(computed(() => !this.valid()));

    invalidOutput = output<boolean>({
        alias: "invalid",
    });

    constructor() {
        super();

        this.invalid.subscribe({
            next: (value) => {
                this.invalidOutput.emit(value);
            },
        });
    }
}
